import React, { useContext, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { LoaderContext } from '../../AuthContext/AuthContext';
import { GetPujaLookupList } from '../../ApiServices/Puja/PujaApi';
import { t } from 'i18next';
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import NoResultFoundModel from '../NoDataFound/NoDataFoundModal';
import { pujaServiceID, pujaSubServiceID } from '../enum';
import HoroscopeBannerImg from "../../assets/images/new/banner-remid.jpeg";


const TemplePujaList = () => {
    const scrollRefs = useRef({});
    const navigate = useNavigate()
    const location = useLocation()
    const user_id = localStorage.getItem("userID");

    const [totalRecords, setTotalRecords] = useState(0);
    const { setLoader, selectedLanguageID, pujaStatus, setPujaStatus, formatToIndianCurrency } = useContext(LoaderContext);

    const [isOnlineSelected, setIsOnlineSelected] = useState(false);
    const [pujaList, setPujaList] = useState([]);
    const [categories, setCategories] = useState([
        { value: 1, label: 'Remedy', count: 0 },
        { value: 2, label: 'Homam', count: 0 },
        { value: 3, label: 'Remedy Subscription', count: 0 },
        { value: 4, label: 'Homam Subscription', count: 0 },
    ])

    const [selectedCategory, setSelectedCategory] = useState(1)
    const [selectedPujaSubServiceID, setSelectedPujaSubServiceID] = useState(null)
    const [selectedPujaServiceID, setSelectedPujaServiceID] = useState(null)

    const [isCatUpdated, setIsCatUpdated] = useState(false)

    useEffect(() => {
        GetCatLookupListData()
    }, [])

    useEffect(() => {
        GetCatLookupListData()
    }, [selectedLanguageID])




    // Reset Selected Cat 
    useEffect(() => {


        if (isCatUpdated) {

            const storedCatId = sessionStorage.getItem("selectedTemplePujaCatId");
            if (storedCatId !== null && storedCatId !== undefined && storedCatId !== "") {
                setSelectedCategory(storedCatId)
                GetPujaLookupListData(3, 5, storedCatId)
            } else {
                setSelectedCategory(categories[0].pujaCatKeyID)
                GetPujaLookupListData(3, 5, categories[0].pujaCatKeyID)
            }

            setIsCatUpdated(false)
        }
    }, [isCatUpdated])

    // -------------------API Calling----------------
    const GetCatLookupListData = async () => {

        const isRemedy = Number(location?.state?.details?.remedyPujaCount) > 0;
        const isHomam = Number(location?.state?.details?.homamPujaCount) > 0;
        const isSubRemedy = Number(location?.state?.details?.subscriptionRemedyPujaCount) > 0;
        const isSubHomam = Number(location?.state?.details?.subscriptionHomamPujaCount) > 0;

        const updatedCategoryArray = [];

        if (isRemedy) {
            updatedCategoryArray.push({
                value: 1,
                pujaServiceID: pujaServiceID?.Puja,
                pujaSubServiceID: pujaSubServiceID?.RemedyPuja,
                name: "Remedy Puja"
            });
        }
        if (isHomam) {
            updatedCategoryArray.push({
                value: 2,
                pujaServiceID: pujaServiceID?.Puja,
                pujaSubServiceID: pujaSubServiceID?.HomamPuja,
                name: "Homam Puja"
            });
        }



        if (isSubRemedy) {
            updatedCategoryArray.push({
                value: 3,
                pujaServiceID: pujaServiceID?.SankalpPuja,
                pujaSubServiceID: pujaSubServiceID?.SubscriptionRemedyPuja,
                name: "Subscription Remedy Puja"
            });
        }

        if (isSubHomam) {
            updatedCategoryArray.push({
                value: 4,
                pujaServiceID: pujaServiceID?.SankalpPuja,
                pujaSubServiceID: pujaSubServiceID?.SubscriptionHomamPuja,
                name: "Subscription Homam Puja"
            });
        }
        setCategories(updatedCategoryArray)
        GetPujaLookupListData(pujaServiceID?.Puja, pujaSubServiceID?.RemedyPuja)
    };

    const GetPujaLookupListData = async (pujaServiceID, pujaSubServiceID, selectedCategory) => {

        setLoader(true);
        try {
            const response = await GetPujaLookupList({
                applangID: Number(selectedLanguageID),
                pujaServiceID: pujaServiceID || selectedPujaServiceID,
                pujaSubServiceID: pujaSubServiceID || selectedPujaSubServiceID,
                pujaCatKeyID: null,
                templeID: location?.state?.templeID
            });

            if (response?.statusCode === 200) {
                const list = response?.responseData?.data
                setPujaList(list);
                setTotalRecords(list?.length);
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    // ----------------------------------Other Functions---------------------------------

    const viewDetail = (product) => {
        const newSlug = product?.pujaSlug;
        if (selectedCategory) {
            sessionStorage.setItem("selectedCatId", selectedCategory);
        }
        navigate(`/service/puja-details/${newSlug}`, {
            state: { puja: product, serviceName: 'PujaAtTemple' },
        });
    };

    const handleCatChange = (category) => {
        setTotalRecords(-1)
        setPujaList([])
        setSelectedCategory(category?.value)
        setSelectedPujaServiceID(category?.pujaServiceID)
        setSelectedPujaSubServiceID(category?.pujaSubServiceID)
        GetPujaLookupListData(category?.pujaServiceID, category?.pujaSubServiceID)
    };

    return (
        <>
            <section className="page-header" style={{ paddingBottom: '28px' }}>
                <div
                    className="page-header__bg horoscope-banner-responsive"
                    style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
                ></div>
                <div className="container" style={{ display: 'block' }}>
                    <h2 className="page-header__title bw-split-in-left">{t("Temple Pujas")}</h2>

                </div>
            </section>
            <div className="container-fluid my-4">
                {/* -------- Mobile View: Horizontal Categories -------- */}
                <fieldset className="border rounded mb-3 d-block d-md-none">
                    <legend className="float-none w-auto px-2 fw-bold" style={{ fontSize: "14px" }}>
                        {t("categories")}
                    </legend>
                    <div className="d-block d-md-none">
                        <div
                            className="d-flex overflow-auto"
                            style={{
                                whiteSpace: "nowrap",
                                scrollbarWidth: "none", // Firefox hide scrollbar
                                borderBottom: "1px solid #ddd",
                                paddingBottom: "4px",
                                gap: "24px",
                            }}
                        >
                            {categories?.map((cat) => (
                                <div
                                    key={cat.value}
                                    ref={(el) => (scrollRefs.current[cat.value] = el)}
                                    onClick={() => {
                                        handleCatChange(cat);

                                        // scroll selected category to center
                                        const el = scrollRefs.current[cat.value];
                                        if (el) {
                                            el.scrollIntoView({
                                                behavior: "smooth",
                                                inline: "center", // horizontal centering
                                                block: "nearest",
                                            });
                                        }
                                    }}
                                    style={{
                                        position: "relative",
                                        cursor: "pointer",
                                        textTransform: "uppercase",
                                        fontWeight: selectedCategory === cat.value ? "600" : "400",
                                        color: selectedCategory === cat.value ? "#991b3d" : "#000",
                                    }}
                                >
                                    <span>{t(cat.label)}</span>

                                    {/* underline for active item */}
                                    <span
                                        style={{
                                            position: "absolute",
                                            left: 0,
                                            right: 0,
                                            bottom: "-4px",
                                            height: "2px",
                                            backgroundColor: "#991b3d",
                                            transform:
                                                selectedCategory === cat.value ? "scaleX(1)" : "scaleX(0)",
                                            transformOrigin: "center",
                                            transition: "transform 0.25s ease",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                </fieldset>

                <div className="row">
                    {/* -------- Desktop Sidebar -------- */}
                    <aside className="col-md-3 d-none d-md-block " >

                        <div>
                            <h4 className='px-3 pt-3' >{t("Puja Category")}</h4>
                        </div>
                        <hr />
                        <div
                            className=" p-3"
                            style={{ maxHeight: "50vh", overflowY: "auto", scrollbarWidth: "none" }}
                        >

                            <ul className="list-unstyled" style={{ cursor: "pointer" }}>
                                {categories?.map((cat, i) => (
                                    <li key={cat.value} className="mb-2" onClick={() => handleCatChange(cat)} style={{ cursor: "pointer" }}>
                                        <label className={`form-check-label small ${selectedCategory === cat.value ? "activeText" : ''}`} style={{ cursor: "pointer" }}>
                                            <i className="fa fa-angle-right me-2"></i>
                                            {t(cat.name)}
                                        </label>
                                    </li>
                                ))}
                            </ul>
                        </div>

                    </aside>



                    {/* -------- Puja Grid -------- */}
                    <main className="col-md-9 col-12" >
                        <div className="row g-2 mt-1 " style={{ maxHeight: "100vh", overflowY: "auto", scrollbarWidth: "none", justifyContent: 'left' }}>
                            {pujaList?.map((puja, index) => (
                                <div
                                    className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4 "

                                    onClick={() => viewDetail(puja)}
                                >
                                    <div

                                        className="card shadow-sm  rounded-3 h-100 border bolder-dark"
                                        style={{ cursor: "pointer", overflow: "hidden" }}

                                    >
                                        {/* Image Section */}
                                        <div className="position-relative">
                                            <img
                                                src={puja.pujaImageUrl || pandit}
                                                alt={puja.pujaName}
                                                className="card-img-top"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = pandit;
                                                }}
                                                style={{
                                                    height: "150px",
                                                    objectFit: "fill",
                                                    borderTopLeftRadius: "12px",
                                                    borderTopRightRadius: "12px",
                                                }}
                                            />

                                            {/* Date Badge */}
                                            {/* <div
                                                className="position-absolute top-0 end-0 bg-white text-center shadow-sm"
                                                style={{
                                                    borderRadius: "0 0 6px 6px",
                                                    padding: "6px 10px",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                    color: "#8f3246",
                                                }}
                                            >
                                                <div>{puja.DATE || "29"}</div>
                                                <div style={{ fontSize: "10px" }}>
                                                    {puja.MONTH || "AUG"}
                                                </div>
                                            </div> */}
                                        </div>

                                        {/* Card Body */}
                                        <div className="card-body p-2 d-flex flex-column">
                                            <h6
                                                className="card-title fw-bold mb-1 listpages-marathi-content"
                                                style={{ color: "#8f3246", fontSize: "16px" }}
                                            >
                                                {puja.pujaName}
                                            </h6>

                                            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                                                {puja.PUJA_TAGLINE || "A powerful ritual description..."}
                                            </p>



                                            {/* Price & Button */}
                                            <div className="mt-auto">
                                                <span
                                                    className="fw-bold"
                                                    style={{ fontSize: "16px", color: "#000" }}
                                                >
                                                    ₹
                                                    {
                                                        puja.onlinePujaPrice
                                                            ? formatToIndianCurrency(Math.round(puja.onlinePujaPrice - (puja.onlinePujaDiscountAmount || 0)))
                                                            : formatToIndianCurrency(Math.round(puja.offlinePujaPrice - (puja.offlinePujaDiscountAmount || 0)))
                                                    }
                                                </span>
                                                <button
                                                    className="btn w-100 mt-2"
                                                    style={{
                                                        backgroundColor: "#8f3246",
                                                        color: "#fff",
                                                        borderRadius: "8px",
                                                        textTransform: "none",
                                                    }}
                                                >
                                                    <span className="blink-text"
                                                        onClick={() => viewDetail(puja)}
                                                    >
                                                        {t("Book Puja Now")}
                                                    </span>
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {totalRecords <= 0 && <NoResultFoundModel totalRecords={totalRecords} />}
                        </div>
                    </main>
                </div>
            </div>
        </>
    )
}

export default TemplePujaList
